import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './styles.css';
import appearances from './appearances.css';

export default function HomeBlock({
  title,
  subtitle,
  image,
  image2x,
  caption,
  reversed,
  appearance,
}) {
  const insideClass = cx(styles.blockInside, {
    [styles.reverse]: reversed,
  });

  const blockClass = cx(styles.block, appearances[appearance]);

  return (
    <div className={blockClass}>
      <div className={insideClass}>
        <div className={styles.textContent}>
          <h3 className={styles.blockTitle}>{title}</h3>
          <p className={styles.blockSubtitle}>{subtitle}</p>
        </div>
        <div>
          <img alt={caption} src={image} srcSet={`${image2x} 2x`} />
        </div>
      </div>
    </div>
  );
}

HomeBlock.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.string.isRequired,
  image: PropTypes.node.isRequired,
  image2x: PropTypes.node.isRequired,
  caption: PropTypes.string.isRequired,
  reversed: PropTypes.bool,
  appearance: PropTypes.oneOf(Object.keys(appearances)).isRequired,
};

HomeBlock.defaultProps = {
  reverse: false,
};
